import React, { Component } from "react";

import {
  CBadge,
  CCardBody,
  CCol,
  /* CProgress, */ CRow,
  CCard,
  CCardFooter,
  CButton
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import ImgNoData from "../../../../assets/imgs/graduation.svg";
import Breadcrumb from "../../../../components/Breadcrumb";
import CircularProgress from "../../../../components/CircularProgress";
import CorrectLiterarte from "../../../../components/CorrectLiterarte";
import CorrectQuestionList from "../../../../components/CorrectQuestionList";
import CorrectUpload from "../../../../components/CorrectUpload";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { formatDate, interval } from "../../../../utils/date";

class ActivityCorrect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      execution: [],
      questionListModal: false,
      literarteModal: false,
      uploadModal: false,
      obj_id: null,
      item_id: null,
      showPhoto: false,
      photo: ""
    };
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    if (this.props.match.params.execution_id !== "0") {
      this.updateItems();
      // this.pullApplications();
    }
  }

  pullApplications(callback = () => null) {
    const filter = {
      user_id: this.props.user_id,
      allocation_id: this.state.allocation_id,
      list_id: this.state.listId
    };

    axios
      .post(`${URL.api}evaluation/application/list`, filter, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        const bestTry = resp.data.data.reduce((acc, val) => {
          if (acc) {
            if (
              parseFloat(val.final_grade) >
              parseFloat(
                resp.data.data.find(item => item.try === acc).final_grade
              )
            ) {
              return val.try;
            }

            return acc;
          }

          return val.try;
        }, null);

        this.setState(
          {
            photo: resp.data.data[0].photo
          },
          () => callback()
        );
      });
  }

  async updateItems() {
    const respExecution = await axios.get(
      `${URL.api}activity/execution/singleView/${this.props.match.params.execution_id}`,
      { headers: { authorization: `Bearer ${this.props.user.token}` } }
    );
    const respActivity = await axios.get(
      `${URL.api}activity/activity/singleViewByExecution/${this.props.match.params.execution_id}?allocation_id=${this.props.match.params.allocation_id}`,
      { headers: { authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState(
      {
        execution: respExecution.data.data,
        activity: respActivity.data.data,
        loading: false
      },
      async () => {
        // 1. Verifica se o ID do criador da atividade é o mesmo que o do usuário
        // que está tentando acessar activity/do/:id/correct/:id
        if (this.state.activity?.user_id !== this.props.user.user.id) {
          // Se não for, verifica quem criou a atividade
          const getActivityCreatorUser = await axios.get(
            `${URL.api}access/user/singleView/${this.state.activity.user_id}`,
            { headers: { authorization: `Bearer ${this.props.user.token}` } }
          );
          // roles do usuário que criou a atividade
          const activityCreatorUserRole =
            getActivityCreatorUser.data.data.user_role;
          // role_ids do tipo administrador (educandus, escolar, etc.)
          const adminRoles = [1, 2, 3, 4];
          // Se o autor da atividade for um administrador, ela se torna
          // acessível (activity/do/:id/correct/:id)
          if (
            // 2. Se o criador da ativiadde não for um administrador
            activityCreatorUserRole.filter(role =>
              adminRoles.includes(role.role_id)
            ).length <= 0 ||
            // Ou se ele for um aluno
            this.props.user.user_roles.filter(role =>
              [7, 9].includes(role.role_id)
            ).length >= 1
          ) {
            // Então o acesso não deveria ser permitido.
            toastr.error(
              "Sem permissão",
              "Infelizmente você não tem permissão para acessar os resultados da avaliação."
            );
            this.props.history.push("/");
          }
        }
      }
    );
  }

  hasCorrection(type) {
    return [12, 18, 15, 14, 22, 24].includes(type);
  }

  correctItem(item) {
    switch (item.type_id) {
      case 12:
        this.setState({
          questionListModal: true,
          obj_id: item.obj_id,
          item_id: item.id,
          showPhoto: false
        });
        break;
      case 14:
        this.setState({
          literarteModal: true,
          obj_id: item.obj_id,
          item_id: item.id,
          showPhoto: false
        });
        break;
      case 18:
        this.setState({
          uploadModal: true,
          obj_id: item.obj_id,
          item_id: item.id,
          showPhoto: false
        });
        break;
      default:
        break;
    }
  }

  showGabarito(item) {
    this.setState({
      questionListModal: true,
      obj_id: item.obj_id,
      item_id: item.id,
      showPhoto: true
    });
  }

  render() {
    if (this.props.match.params.execution_id === "0") {
      return (
        <>
          <Breadcrumb
            current={this.props.currentRoute}
            items={[
              { path: "/classroom/me", to: "/classroom/me" },
              {
                path: "/classroom/:id/activities",
                to: `/classroom/${this.state.activity?.room_id}/activities`
              },
              {
                path: "/activity/do/:allocation_id",
                to: `/activity/do/${this.props.match.params.allocation_id}`
              }
            ]}
          />
          <CRow className="flex-1 mt-3">
            <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
              <img
                src={ImgNoData}
                style={{ height: "240px", marginBottom: "2rem" }}
                alt=""
              />
              <p
                style={{ fontSize: "1.5rem" }}
                className="mb-2 font-weight-bold text-center"
              >
                Esse estudante ainda não abriu a atividade
              </p>
              <span className="text-muted text-center">
                Tente voltar daqui a alguns minutos
              </span>
            </div>
          </CRow>
        </>
      );
    }

    return (
      <>
        {this.state.loading ? (
          <Loading />
        ) : (
          <>
            <CRow className="mb-4">
              <CCol>
                <Breadcrumb
                  current={this.props.currentRoute}
                  items={[
                    { path: "/classroom/me", to: "/classroom/me" },
                    {
                      path: "/classroom/:id/activities",
                      to: `/classroom/${this.state.activity?.room_id}/activities`
                    },
                    {
                      path: "/activity/do/:allocation_id",
                      to: `/activity/do/${this.props.match.params.allocation_id}`
                    }
                  ]}
                />
                <h1 className="d-flex align-items-center">
                  Histórico de {this.state.activity.name}
                </h1>
                <h5 className="d-flex align-items-center">
                  <img
                    src={
                      URL.img +
                      (this.state.execution.user_photo ||
                        "uploads/users/profileEmpty.jpg")
                    }
                    alt=""
                    style={{
                      borderRadius: "100%",
                      width: "2rem",
                      height: "2rem",
                      marginRight: "0.75rem"
                    }}
                  />
                  {this.state.execution.user_name}
                </h5>
              </CCol>
            </CRow>
            <CRow className="mb-4">
              <CCol className="d-flex align-items-center">
                <div
                  style={{ width: "6rem", height: "6rem" }}
                  className="mr-3 position-relative d-flex align-items-center justify-content-center"
                >
                  <CircularProgress
                    progress={this.state.activity.activity_percentage}
                  />
                  <h4 className="position-absolute mb-0">
                    {this.state.activity.activity_percentage}%
                  </h4>
                </div>
                <div>
                  <h5 className="mr-2 mb-2">
                    Concluiu{" "}
                    {
                      this.state.activity.items.filter(
                        item => item.item_percentage >= 100
                      ).length
                    }{" "}
                    dos {this.state.activity.items.length} itens
                  </h5>
                  <h3 className="mb-0 text-primary">
                    {this.state.activity.activity_percentage >= 100
                      ? "Concluído"
                      : "A fazer"}
                  </h3>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol className="mt-1">
                {this.state.activity.items.map(item => (
                  <CCard
                    key={item.id}
                    accentColor={
                      item.item_percentage < 100 ? "secondary" : "primary"
                    }
                  >
                    <CCardBody>
                      <div className="d-flex align-items-center">
                        <h5 className="m-0 flex-1">
                          <i
                            className={`fa fa-${item.type_icon} text-${item.type_color} mr-3`}
                          ></i>
                          {item.name}
                        </h5>
                        <CBadge
                          color={
                            item.item_percentage < 100 ? "secondary" : "primary"
                          }
                        >
                          {item.item_percentage || "0"}%
                        </CBadge>
                      </div>
                      <div className="d-flex align-items-center text-muted small mt-3">
                        <i className="fa fa-clock-o mr-2"></i>Início:{" "}
                        {item.item_start ? formatDate(item.item_start) : "-"}
                        <span className="mx-3">|</span>
                        <i className="fa fa-flag mr-2"></i>Fim:{" "}
                        {item.item_end ? formatDate(item.item_end) : "-"}
                        <span className="mx-3">|</span>
                        <i className="fa fa-hourglass-3 mr-2"></i>Tempo total:{" "}
                        {item.item_end
                          ? interval(item.item_start, item.item_end)
                          : "-"}
                      </div>
                    </CCardBody>
                    {this.hasCorrection(item.type_id) && (
                      <CCardFooter
                        className="align-items-center"
                        style={{ backgroundColor: "#f8f9fa" }}
                      >
                        <div className="flex-1 small align-items-center d-flex">
                          Nota:&nbsp;<b>{item.item_grade || "Não corrigido"}</b>
                        </div>

                        {item.type_id === 12 && this.state.photo !== "" && (
                          <CButton
                            color="primary"
                            size="sm"
                            onClick={() => this.showGabarito(item)}
                            style={{ marginRight: "10px" }}
                          >
                            Ver cartão resposta
                          </CButton>
                        )}

                        <CButton
                          color="primary"
                          size="sm"
                          onClick={() => this.correctItem(item)}
                        >
                          Corrigir
                        </CButton>
                      </CCardFooter>
                    )}
                  </CCard>
                ))}
              </CCol>
            </CRow>
            {this.state.questionListModal && (
              <CorrectQuestionList
                show
                onClose={() =>
                  this.setState({ questionListModal: false }, () =>
                    this.updateItems()
                  )
                }
                activityId={this.state.activity.id}
                currentRoute={this.props.currentRoute}
                allocation_id={parseInt(this.props.match.params.allocation_id)}
                id={this.state.obj_id}
                history={this.props.history}
                item_id={this.state.item_id}
                execution_id={parseInt(this.props.match.params.execution_id)}
                user_id={this.state.execution.user_id}
                showPhoto={this.state.showPhoto}
              />
            )}
            {this.state.literarteModal && (
              <CorrectLiterarte
                show
                onClose={() =>
                  this.setState({ literarteModal: false }, () =>
                    this.updateItems()
                  )
                }
                activityId={this.state.activity.id}
                currentRoute={this.props.currentRoute}
                allocation_id={parseInt(this.props.match.params.allocation_id)}
                id={this.state.obj_id}
                history={this.props.history}
                item_id={this.state.item_id}
                execution_id={parseInt(this.props.match.params.execution_id)}
                user_id={this.state.execution.user_id}
              />
            )}
            {this.state.uploadModal && (
              <CorrectUpload
                show
                onClose={() =>
                  this.setState({ uploadModal: false }, () =>
                    this.updateItems()
                  )
                }
                activityId={this.state.activity.id}
                currentRoute={this.props.currentRoute}
                allocation_id={parseInt(this.props.match.params.allocation_id)}
                id={this.state.obj_id}
                history={this.props.history}
                item_id={this.state.item_id}
                execution_id={parseInt(this.props.match.params.execution_id)}
                user_id={this.state.execution.user_id}
              />
            )}
          </>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  general: state.general,
  user: state.user,
  note: state.note
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityCorrect);
